<template>
  <div class="app-wrapper" :class="{hideSidebar:!sidebar.opened}">
  <!--<div class="app-wrapper" :class="{hideSidebar:false}">-->
    <!--<span class="test"> wo shi test </span>-->
    <sidebar class="sidebar-container" :opened='sidebar.opened'></sidebar>
    <div class="main-container">
      <navbar></navbar>
      <!--<tags-view></tags-view>-->
      <app-main></app-main>
    </div>
  </div>
</template>

<script>
//  import { Navbar, Sidebar, AppMain, TagsView } from 'views/layout/components'
  import { Navbar, Sidebar, AppMain, TagsView } from '@/views/layout/components'
//  import {Navbar, Sidebar, AppMain, TagsView} from './components'

  export default {
    name: 'layout',
    components: {
      Navbar,
      Sidebar,
      AppMain,
      TagsView
    },
    computed: {
      sidebar() {
        return this.$store.state.app.sidebar
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "src/styles/mixin.scss";
  /*@import '../../styles/mixin.scss';*/
  /*@import '../../styles/variables.scss';*/
  /*@import "../../styles/sidebar.scss";*/

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue